import React from 'react';
import {dropdownFillBlack} from 'assets/images/images';
import {Accordion} from '../../../components';
import {DetailRow} from './DetailRow';

function FinancialActivity({data = {}}) {
  const {
    transaction_overview = {},
    channel_distribution = {},
    top_counterparties = [],
    loan_summary = {},
    payment_behavior = {},
  } = data;

  return (
    <div className="bg-white rounded-xl py-4 flex flex-col gap-4">
      <div className="px-6 flex flex-col gap-1">
        <h4 className="text-deepBlue font-medium">Financial Activity</h4>
      </div>

      <div className="px-3 flex flex-col gap-4">
        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Transaction Overview"
        >
          <div className="mt-1">
            <DetailRow
              label="Lifetime Count"
              value={transaction_overview.lifetime_count}
            />
            <DetailRow
              label="Lifetime Value"
              value={transaction_overview.lifetime_value}
            />
            <DetailRow
              label="Rolling 30-Day Activity"
              value={transaction_overview.rolling_30_day_activity}
            />
            <DetailRow
              label="Average Ticket Size"
              value={transaction_overview.average_ticket_size}
            />
            <DetailRow
              label="Velocity Delta"
              value={transaction_overview.velocity_delta}
            />
          </div>
        </Accordion>

        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Channel Distribution"
        >
          <div className="mt-1">
            <DetailRow label="Mobile" value={channel_distribution.mobile} />
            <DetailRow label="Web" value={channel_distribution.web} />
            <DetailRow label="POS" value={channel_distribution.pos} />
          </div>
        </Accordion>

        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Top Counterparties"
        >
          <div className="mt-1">
            {top_counterparties.map((item, index) => (
              <DetailRow key={index} label={item.name} value={item.value} />
            ))}
          </div>
        </Accordion>

        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Loan Summary"
        >
          <div className="mt-1">
            <DetailRow label="Active Loans" value={loan_summary.active_loans} />
            <DetailRow
              label="Outstanding Balance"
              value={loan_summary.outstanding_balance}
            />
            <DetailRow
              label="On-Time Payment Rate"
              value={loan_summary.on_time_payment_rate}
            />
            <DetailRow
              label="Loan Risk Indicators"
              value={loan_summary.loan_risk_indicators}
              valueClassName="text-[#DC6803] bg-[#FFF8EB] px-2 py-1 text-small rounded-full"
            />
          </div>
        </Accordion>

        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Payment Behavior"
        >
          <div className="mt-1">
            <DetailRow
              label="Dominant Method"
              value={payment_behavior.dominant_method}
            />
            <DetailRow
              label="Success Rate"
              value={payment_behavior.success_rate}
            />
            <DetailRow
              label="3DS/AVS Failure Rate"
              value={payment_behavior['3ds_avs_failure_rate']}
            />
          </div>
        </Accordion>

        <div className="flex p-3 items-center justify-between border border-[#F3F4F7] rounded-xl">
          <p className="text-tiny text-[#0B1C56] font-medium">
            Financial Flags
          </p>
          <p className="text-small font-medium text-[#B42318] bg-[#F8EBEA] py-1 px-2 rounded-full">
            Transaction velocity surge
          </p>
        </div>
      </div>
    </div>
  );
}

export default FinancialActivity;
